/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { availabilityStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAvailability";
import { css } from "styled-components";

availabilityStyles.availability = {
    container: {
        gap: 0,
        css: css`
            flex-grow: 0;
            margin-top: 20px;
        `,
    },
};

(availabilityStyles as any).messagePanel = {
    wrapper: {
        css: css`
            margin-top: 20px;
        `,
    },
    content: {
        size: "13px",
        lineHeight: "18px",
        css: css`
            a {
                span {
                    font-size: 13px;
                }
            }
        `,
    },
};
